import * as React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import { useOOGlobals } from '@local/do-secundo-oo-globals-provider'
const MultiLocationPage = React.lazy(() =>
  import(
    /* webpackChunkName: "MultiLocationPage" */ '../MultiLocationPage/MultiLocationPage'
  )
)
export const MultiLocationPickerApp = () => {
  const { routerBasename } = useOOGlobals()

  return (
    <BrowserRouter basename={routerBasename}>
      <Switch>
        <Route component={MultiLocationPage} exact path='/' />
        <Redirect to='/' />
      </Switch>
    </BrowserRouter>
  )
}
